module.exports = __webpack_public_path__ + "img/config__btn.d2f37672.svg";